import Vue from 'vue'
import UiBreadcrumbs from '@/components/ui/common/ui-breadcrumbs/ui-breadcrumbs.vue'
import UiImage from '@/components/ui/common/ui-image/index.vue'
import UiInput from '@/components/ui/common/ui-input/index.vue'
import UiModal from '@/components/ui/common/ui-modal/ui-modal.vue'
import UiPagination from '@/components/ui/common/ui-pagination/index.vue'
import UiLink from '@/components/ui/common/ui-link/index.vue'
import UiButton from '@/components/ui/common/ui-button/index.vue'
import UiCheckbox from '@/components/ui/common/ui-checkbox/index.vue'
import UiSelect from '@/components/ui/common/ui-select/index.vue'
import UiFilesUploader from '@/components/ui/common/ui-files-uploader/index.vue'
import FormModal from '~/components/blocks/form-modal.vue'
import UiPopupMenu from '~/components/ui/common/ui-popup-menu/index.vue'
import UiCookie from '~/components/ui/cookie/index.vue'

// Создаем объект с компонентами
const components = {
  UiBreadcrumbs,
  UiImage,
  UiInput,
  UiModal,
  UiPagination,
  UiLink,
  UiCheckbox,
  UiButton,
  UiSelect,
  UiFilesUploader,
  FormModal,
  UiPopupMenu,
  UiCookie
}

// Регистрируем каждый компонент глобально
Object.entries(components).forEach(([name, component]) => {
  // @ts-ignore
  Vue.component(name, component)
})
